import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Customers',
	url: '/customers',
	icon: 'users',
}];

export default class Customers extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					{/*commented out due to not having address which is required, and nobody used this*/}
					{/*<Button data-cy="add-customer" onClick={this.toggle('modalCustomerAdd')} size={"sm"} color="primary">*/}
					{/*	<i className="fa fa-users"/>&nbsp;&nbsp;Add Customer*/}
					{/*</Button>*/}
				</Framework.Components.PageBar>

				<Collections.Customers
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Customer"}
					object={Objects.Customer}
					history={history}
					toggle={this.state.modalCustomerAdd}
					reportClose={this.reportClose('modalCustomerAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
				/>

			</div>
		);
	}
}

